import { p as parameter, k as db } from './prodsel.store-B-MQAyQE.mjs';

async function resolveCurrentPricegroup(destinationCountry, countryParameter) {
    const normalizedDestinationCountry = destinationCountry || 'DE';

    let resolvedCountryParameter = countryParameter;
    if (!resolvedCountryParameter || typeof resolvedCountryParameter !== 'object') {
        resolvedCountryParameter = await parameter.country;
    }

    const pricegroupDef = resolvedCountryParameter?.pricegroup_def || {};
    return pricegroupDef[normalizedDestinationCountry] || pricegroupDef.DE || 'DE_1'
}

async function loadPricesForPid(pid, pricegroup) {
    if (!pid) return []

    const pricesInGroup = await db.prices.where('pid').equals(pid).and((item) => item.priceGroup === pricegroup).toArray();
    if (pricesInGroup.length > 0) return pricesInGroup

    return db.prices.where('pid').equals(pid).toArray()
}

async function hydrateCartRuntimePrices({ items = [], destinationCountry = 'DE', countryParameter, getItemKey }) {
    const list = Array.isArray(items) ? items : [];
    const resolveItemKey = typeof getItemKey === 'function'
        ? getItemKey
        : (_item, index) => `item-${index}`;

    const pricegroup = await resolveCurrentPricegroup(destinationCountry, countryParameter);
    const productPricesByItemKey = {};
    const optionPricesByItemKey = {};

    for (let index = 0; index < list.length; index++) {
        const item = list[index];
        const itemKey = resolveItemKey(item, index);

        productPricesByItemKey[itemKey] = await loadPricesForPid(item?.product?.pid, pricegroup);

        const optionPricesForItem = {};
        const selectedOptionPrices = Array.isArray(item?.selectedOptionPrices) ? item.selectedOptionPrices : [];

        for (const optionPrice of selectedOptionPrices) {
            const optionPid = optionPrice?.pid;
            if (!optionPid || optionPricesForItem[optionPid]) continue

            optionPricesForItem[optionPid] = await loadPricesForPid(optionPid, pricegroup);
        }

        optionPricesByItemKey[itemKey] = optionPricesForItem;
    }

    return {
        pricegroup,
        productPricesByItemKey,
        optionPricesByItemKey
    }
}

function redirectAction(redirectConfig, router, location = document.location) {
    const method = redirectConfig?.method || 'router';
    const path = redirectConfig?.path || '/shop';

    if (method === 'location') {
        location.href = path;
        return
    }

    router.push(path);
}

export { hydrateCartRuntimePrices as h, redirectAction as r };
